import {
    Component,
    h,
    Prop,
} from '@stencil/core';

@Component({
    tag: 'portal-menu-link',
    styleUrl: 'portal-menu-link.scss',
    shadow: true,
})
export class PortalMenuLink {
    /**
     * The primary text on the menu item
     * @memberof PortalMenuLink
     */
    @Prop() text: string;

    /**
     * The aria-role for the menu item
     * @memberof PortalMenuLink
     */
    @Prop() itemRole?: string;

    /**
     * The link href
     * @memberof PortalMenuLink
     */
    @Prop() href: string;

    render() {
        return (
            <div {...(this.itemRole ? { role: this.itemRole } : {})}>
                <a
                    tabindex={'-1' /* tab behavior is handled by parent menu */}
                    href={this.href}
                    target={'_blank'}
                    class={'menu-item-base menu-link-base'}
                    style={{ '--cursor': 'pointer' }}
                >
                    <span class={'menu-link-text menu-text'}>{this.text}</span>
                </a>
            </div>
        );
    }
}

